import { AiDownloadModel, AmortizationDetailModel, AmortizationScheduleModel, BankToTbTransactionsInterface, CAASGlModel, ChatLucaMsgModel, ChatsModel, EngagementIntegrationInfo, GlGroupModel, GlSubGroupModel, GlTbModel, LsAccountsModel, LucaEngListModel, LucaFileModel, SORT_OPTIONS, TbAccountInterface, TbAccountModel } from 'countable@model';
import { FileDataModel } from '../model/docrepo/file-data.model';
import { IntegrationSourceInterface } from '../model/eng/integration-source.interface';
import { PayrollInfoInterface } from '../model/luka/conversation/input-info/payroll-info.interface';
import { RentInputInterface } from '../model/luka/conversation/input-info/rent-input.interface';

export class AiUtility {
  static getEngIntegrationInfo(tenantInfo: IntegrationSourceInterface) {
    const integrationDetails: EngagementIntegrationInfo = new EngagementIntegrationInfo();
    if (tenantInfo.integrationId === 1 && tenantInfo.isActive === true) {
      integrationDetails.integrationName = 'QuickBooks';
      integrationDetails.logoPath = '/assets/images/quickbook/active-qb.png';
      integrationDetails.integrationId = 1;
      integrationDetails.orgName = tenantInfo.organization;
      integrationDetails.isActiveConnection = true;
      integrationDetails.isConnected = tenantInfo.isConnected;
      integrationDetails.sourceName = 'QUICKBOOK';
    } else if (tenantInfo.integrationId === 1 && tenantInfo.isActive === false) {
      integrationDetails.integrationName = 'QuickBooks';
      integrationDetails.logoPath = '/assets/images/quickbook/error-qb.png';
      integrationDetails.integrationId = 1;
      integrationDetails.orgName = tenantInfo.organization;
      integrationDetails.isActiveConnection = false;
      integrationDetails.isConnected = tenantInfo.isConnected;
      integrationDetails.sourceName = 'QUICKBOOK';
    } else if (tenantInfo.integrationId === 2 && tenantInfo.isActive === true) {
      integrationDetails.integrationName = 'Xero';
      integrationDetails.logoPath = '/assets/images/xero-img.png';
      integrationDetails.integrationId = 2;
      integrationDetails.orgName = tenantInfo.organization;
      integrationDetails.isActiveConnection = true;
      integrationDetails.isConnected = tenantInfo.isConnected;
      integrationDetails.sourceName = 'XERO';
    } else if (tenantInfo.integrationId === 2 && tenantInfo.isActive === false) {
      integrationDetails.integrationName = 'Xero';
      integrationDetails.logoPath = '/assets/images/xero/error-xero1.png';
      integrationDetails.integrationId = 2;
      integrationDetails.orgName = tenantInfo.organization;
      integrationDetails.isActiveConnection = false;
      integrationDetails.isConnected = tenantInfo.isConnected;
      integrationDetails.sourceName = 'XERO';
    } else if (tenantInfo.integrationId === 4 && tenantInfo.isActive === true) {
      integrationDetails.integrationName = 'Sage';
      integrationDetails.logoPath = 'assets/images/sage/Sage-logo.png';
      integrationDetails.integrationId = 4;
      integrationDetails.orgName = tenantInfo.organization;
      integrationDetails.isActiveConnection = true;
      integrationDetails.isConnected = tenantInfo.isConnected;
      integrationDetails.sourceName = 'SAGE';
    } else if (tenantInfo.integrationId === 4 && tenantInfo.isActive === false) {
      integrationDetails.integrationName = 'Sage';
      integrationDetails.logoPath = 'assets/images/sage/error-sage.png';
      integrationDetails.integrationId = 4;
      integrationDetails.orgName = tenantInfo.organization;
      integrationDetails.isActiveConnection = false;
      integrationDetails.isConnected = tenantInfo.isConnected;
      integrationDetails.sourceName = 'SAGE';
    }
    return integrationDetails;
  }

  static sortByEngCreatedDate(data: LucaEngListModel[], order: 'ASC' | 'DSC' = 'ASC'): LucaEngListModel[] {
    return data.sort((a, b) => {
      const dateA = new Date(a.engCreatedDate).getTime();
      const dateB = new Date(b.engCreatedDate).getTime();
      return order === 'ASC' ? dateA - dateB : dateB - dateA;
    });
  }

  static sortByYearEnd(data: LucaEngListModel[], order: 'ASC' | 'DSC' = 'ASC'): LucaEngListModel[] {
    return data.sort((a, b) => {
      const dateA = new Date(a.yearEnd).getTime();
      const dateB = new Date(b.yearEnd).getTime();
      return order === 'ASC' ? dateA - dateB : dateB - dateA;
    });
  }

  static sortByName(data: LucaEngListModel[], order: 'ASC' | 'DSC' = 'ASC'): LucaEngListModel[] {
    return data.sort((a, b) => {
      return order === 'ASC' ? a.clientName.localeCompare(b.clientName) : b.clientName.localeCompare(a.clientName);
    });
  }

  static isToday = (date: Date) => {
    const today = new Date();
    return date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear();
  };

  static isYesterday = (date: Date) => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return date.getDate() === yesterday.getDate() &&
      date.getMonth() === yesterday.getMonth() &&
      date.getFullYear() === yesterday.getFullYear();
  };

  static isLastWeek = (date: Date) => {
    const today = new Date();
    const lastWeekStart = new Date();
    lastWeekStart.setDate(today.getDate() - today.getDay() - 7);
    const lastWeekEnd = new Date(lastWeekStart);
    lastWeekEnd.setDate(lastWeekStart.getDate() + 6);
    return date >= lastWeekStart && date <= lastWeekEnd;
  };

  static isThisMonth = (date: Date) => {
    const today = new Date();
    return date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear();
  };

  static isLastMonth = (date: Date) => {
    const today = new Date();
    const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    return date.getMonth() === lastMonth.getMonth() &&
      date.getFullYear() === lastMonth.getFullYear();
  };

  static emptyChatByDate() {
    return new Map<string, ChatsModel[]>([
      ['Today', []],
      ['Yesterday', []],
      ['Last Week', []],
      ['This Month', []],
      ['Last Month', []]
    ]);
  }

  static convertNumValue(total: any, isConvertNumber: boolean = false) {
    let updatedTotal = total?.toLocaleString('en-CA', {
      minimumFractionDigits: 2
    });
    if (isConvertNumber) {
      return updatedTotal.replace('-', '(') + updatedTotal.substring(updatedTotal?.length) + ')';
    }
    return updatedTotal;
  }

  static getAiChatMsg(type: 'USER_PROMPT_INPUT' | 'SYSTEM_PROMPT_RES_LOADING' | 'SYSTEM_PROMPT_RES_OUTPUT' | 'WORKFLOW' | 'SYSTEM_USER', content: string = '') {
    switch (type) {
      case 'SYSTEM_PROMPT_RES_LOADING':
      case 'SYSTEM_PROMPT_RES_OUTPUT':
      case 'WORKFLOW':
        const historyObj: ChatLucaMsgModel = new ChatLucaMsgModel();
        historyObj.messageFrom = 'luca';
        historyObj.lucaMarkdownResponse = content;
        historyObj.lucaResponse = content;
        historyObj.lucaOutputFilePath = '';
        historyObj.lucaResponseHtml = '';
        historyObj.lucaResponseType = 'text';
        historyObj.outputTokens = 0;
        historyObj.messageType = type !== 'WORKFLOW' ? (type === 'SYSTEM_PROMPT_RES_LOADING' ? 'SYSTEM_AI' : 'ASSISTANT') : 'WORKFLOW';
        historyObj.showSpinner = type === 'SYSTEM_PROMPT_RES_LOADING';
        return historyObj;
    }
  }

  static getSortType(type: 'YEAR' | 'DATE' | 'NAME', mode: 'ASC' | 'DSC' | 'DEF' | 'NONE') {
    const sortInfo = SORT_OPTIONS?.filter(s => s?.sort === type)?.find(s => s?.sortType === mode);
    return structuredClone(sortInfo);
  }

  static getAppropriateExtension = (Obj: AiDownloadModel) => {
    if (Obj?.exportType === 'PDF') {
      return '.pdf';
    }
    if (Obj?.exportType === 'XLSX') {
      return '.xlsx';
    }
    if (Obj?.exportType === 'DOCX') {
      return '.docx';
    }
  };

  static getSortActionType(sortType: 'ASC' | 'DSC' | 'DEF' | 'NONE'): 'ASC' | 'DSC' | 'DEF' | 'NONE' {
    if (sortType === 'DEF') {
      return 'ASC';
    }
    if (sortType === 'ASC') {
      return 'DSC';
    }
    if (sortType === 'DSC' || sortType === 'NONE') {
      return 'DEF';
    }
    return 'NONE';
  }

  static convertToLucaFileModel(data: FileDataModel[]): LucaFileModel[] {
    return data.map(fileData => {
      const lucaFile = new LucaFileModel();
      lucaFile.file = null; // Assuming file is not present in FileDataModel
      lucaFile.filePath = fileData.filepath;
      lucaFile.fileName = fileData.filename;
      lucaFile.size = null; // Assuming size is not present in FileDataModel
      lucaFile.fileContent = []; // Assuming fileContent is not present in FileDataModel
      lucaFile.isInProgress = true; // Assuming isInProgress is not present in FileDataModel
      lucaFile.hasUploaded = true;
      lucaFile.extension = fileData.extension;
      lucaFile.fileType = ''; // Assuming fileType is not present in FileDataModel
      lucaFile.progressPercent = 100; // Assuming progressPercent is not present in FileDataModel
      lucaFile.fileId = fileData?.engteamclientdocid?.toString();
      return lucaFile;
    });
  }

  static convertFilesToSaveInfo(files: File[], allowedExt: string[] = []) {
    let updatedFiles: LucaFileModel[] = [];
    files?.forEach(f => {
      const file: LucaFileModel = new LucaFileModel();
      file.size = f?.size / 1024;
      file.fileName = f?.name;
      file.fileType = f?.type;
      file.file = f;
      file.extension = f?.name?.split('.')?.pop()?.toLowerCase();
      file.isInValid = !allowedExt.includes(file.extension);
      file.fileOrigin = 'UPLOAD';
      if ((updatedFiles && updatedFiles?.length > 0)) {
        updatedFiles.push(file);
      } else {
        updatedFiles = [file];
      }
    });
    return structuredClone(updatedFiles);
  }

  static convertRepoFilesToSaveInfo(files: LucaFileModel[], allowedExt: string[] = []) {
    let updatedFiles: LucaFileModel[] = [];
    files?.forEach(f => {
      const file: LucaFileModel = new LucaFileModel();
      file.fileName = f?.fileName;
      file.fileType = f?.fileType;
      file.filePath = f?.filePath;
      file.extension = f?.extension;
      file.isInValid = !allowedExt.includes(file.extension);
      file.fileOrigin = 'REPO';
      file.fileId = f?.fileId;
      if ((updatedFiles && updatedFiles?.length > 0)) {
        updatedFiles.push(file);
      } else {
        updatedFiles = [file];
      }
    });
    return structuredClone(updatedFiles);
  }

  static updateTransformRepoFileInputs(currentFiles: LucaFileModel[], newFiles: LucaFileModel[], allowedExt: string[] = []) {
    const updatedNewFiles = this.convertRepoFilesToSaveInfo(newFiles, allowedExt);
    return currentFiles?.length > 0 ? [...currentFiles, ...updatedNewFiles] : [...updatedNewFiles];
  }

  static updateTransformFileInputs(currentFiles: LucaFileModel[], newFiles: File[], allowedExt: string[] = []) {
    const updatedNewFiles = this.convertFilesToSaveInfo(newFiles, allowedExt);
    return currentFiles?.length > 0 ? [...currentFiles, ...updatedNewFiles] : [...updatedNewFiles];
  }

  static formatNumber(value: any) {
    if (!value) {
      return 0;
    }
    if (typeof value === 'string' && value.includes(',')) {
      return value.replace(/,/g, '');
    }
    return value;
  }

  static parseAndReturnAbs(input: any) {
    if(!input) return 0;
    let cleanedInput = input.replace(/,/g, '');
    if (cleanedInput.startsWith('(') && cleanedInput.endsWith(')')) {
      cleanedInput = '-' + cleanedInput.slice(1, -1);
    }
    return Math.abs(parseFloat(cleanedInput));
  }

  static calculateCB1(OB1: any, ADD: any, DIS: any) {
    const OB1Num = this.parseAndReturnAbs(OB1);
    const ADDNum = this.parseAndReturnAbs(ADD);
    const DISNum = this.parseAndReturnAbs(DIS);
    let result = OB1Num + ADDNum - DISNum;

    return result < 0
      ? `(${Math.abs(result).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})})`
      : result.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
  }

  static performCalculation(valueA: any, valueB: any, type: 'ADD' | 'SUB' = 'SUB'): string {
    const valueANum = this.parseAndReturnAbs(valueA);
    const valueBNum = this.parseAndReturnAbs(valueB);

    let result = 0;
    if (type === 'ADD') {
      result = valueANum + valueBNum;
    } else if (type === 'SUB') {
      result = valueANum - valueBNum;
    }
    return result < 0
      ? `(${Math.abs(result).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})})`
      : result.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
  }

  static formatToNumber(value: string): number {
    if (!value || value === '0.00' || value === '0') {
      return 0.00;
    }
    let cleanedValue = value.replace(/,/g, '');
    const isNegative = /\(([^)]+)\)/.test(cleanedValue);
    if (isNegative) {
      cleanedValue = cleanedValue.replace(/[()]/g, '');
    }
    let numberValue = parseFloat(cleanedValue);
    if (isNegative) {
      numberValue = -numberValue;
    }
    return parseFloat(numberValue.toFixed(2));
  }

  static hasVrInputsValid(percent: string, value: string) {
    return this.isValidNumber(percent) || this.isValidNumber(value);
  }

  static isValidNumber(value: string): boolean {
    const num = parseFloat(value);
    return !isNaN(num) && num > 0;
  }

  static checkIsDeactivated(date: string = '') {
    if (!date) {
      return false;
    }
    const today = new Date();
    const todayEnd = new Date(today.setHours(23, 59, 59, 999)); // Today's end time (11:59:59 PM)
    const deactivatedDate = new Date(date);
    return (this.isSameDay(deactivatedDate, new Date()) && deactivatedDate <= todayEnd);

  }

  static isSameDay(d1: Date, d2: Date): boolean {
    return (
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate()
    );
  }

  static provideInitials(name: string = '') {
    if (!name) {
      return '';
    }
    const words = name.trim().split(/\s+/);
    let initials = '';
    for (const word of words) {
      if (word.length > 0) {
        initials += word[0].toUpperCase();
      }
      if (initials.length === 2) {
        break;
      }
    }
    return initials;
  }

  static setAttachedFiles(files: File[]) {
    const fileMap = new Map<string, File>([]);
    files?.forEach(f => {
      fileMap.set(f?.name, f);
    });
    return fileMap;
  }

  static formatAndTransformValue(input: string | number): string {
    let numberStr = String(input).trim();
    if (!numberStr || isNaN(Number(numberStr.replace(/,/g, '').replace(/[()]/g, '')))) {
      return '0.00';
    }
    let isNegative = false;
    if (numberStr.startsWith('(') && numberStr.endsWith(')')) {
      isNegative = true;
      numberStr = numberStr.slice(1, -1); // Remove brackets
    }
    numberStr = numberStr.replace(/,/g, '');
    let number = parseFloat(numberStr);
    if (isNaN(number) || number === 0) {
      return '0.00';
    }
    let formattedNumber = number.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    if (isNegative || number < 0) {
      formattedNumber = `(${formattedNumber.replace('-', '')})`;
    }
    return formattedNumber;
  }

  static filterSortGroups(tbRows: GlTbModel[] = []) {
    const filteredRows = tbRows?.map(item => <GlGroupModel>{
      groupId: item?.fingroupid,
      groupName: item?.fingroupname
    });
    const uniqueRows = filteredRows?.filter((value, index, self) =>
      index === self.findIndex((t) => t.groupId === value.groupId)
    );
    const sortRows = uniqueRows?.sort((a, b) => a.groupId - b.groupId);
    return structuredClone(sortRows) ?? [];
  }

  static filterSortSubGroups(tbRows: GlTbModel[] = []) {
    const filteredRows = tbRows?.map(item => <GlSubGroupModel>{
      subGroupId: item?.finsubgroupid,
      subGroupName: item?.finsubgroupname,
      groupId: item?.fingroupid
    });
    const uniqueRows = filteredRows?.filter((value, index, self) =>
      index === self.findIndex(v => v.groupId === value.groupId && v.subGroupId === value.subGroupId)
    );
    const sortRows = uniqueRows?.sort((a, b) => a.subGroupId - b.subGroupId);
    return structuredClone(sortRows) ?? [];
  }

  static filterSortLs(tbRows: GlTbModel[] = []) {
    const filteredRows = tbRows?.map(item => <LsAccountsModel>{
      lsName: item?.leadsheetname,
      lsCode: item?.leadsheetcode,
      lsId: item?.leadsheetid,
      subGroupId: item?.finsubgroupid,
      groupId: item?.fingroupid
    });
    const uniqueRows = filteredRows?.filter((item, index, self) =>
        index === self.findIndex(
          (t) => t.lsId === item.lsId && t.subGroupId === item.subGroupId && t.groupId === item.groupId
        )
    );
    const sortRows = uniqueRows?.sort((a, b) => a.lsId - b.lsId);
    return structuredClone(sortRows);
  }

  static filterSortAccounts(tbRows: GlTbModel[] = []) {
    const filteredRows = tbRows?.map(item => <LsAccountsModel>{
      accountCode: item?.accountcode,
      accountName: item?.accountname,
      trialBalId: item?.trailbalanceid,
      finalAmount: item?.finalamount,
      lsId: item?.leadsheetid,
      subGroupId: item?.finsubgroupid,
      groupId: item?.fingroupid
    });
    const uniqueRows = filteredRows?.filter((item, index, self) =>
      index === self.findIndex((t) => t.trialBalId === item.trialBalId)
    );
    const sortRows = uniqueRows?.sort((a, b) => a.trialBalId - b.trialBalId);
    return structuredClone(sortRows);
  }

  static getGroupsFromGl(tbRows: GlTbModel[] = [], groups: number[]) {
    return tbRows?.filter(r => groups?.includes(r?.fingroupid));
  }

  static getSubGroupsFromGl(tbRows: GlTbModel[] = [], subGroups: GlSubGroupModel[] = []) {
    const groups = subGroups?.map(r => r?.groupId);
    const filterGroups = this.getGroupsFromGl(tbRows, groups);
    const subGroup = subGroups?.map(r => r?.subGroupId);
    return filterGroups?.filter(r => subGroup?.includes(r?.finsubgroupid));
  }

  static getLsFromGl(tbRows: GlTbModel[] = [], lsRows: LsAccountsModel[] = []) {
    const groups = lsRows?.map(r => r?.groupId);
    const filterGroups = this.getGroupsFromGl(tbRows, groups);
    const subGroup = lsRows?.map(r => r?.subGroupId);
    const filterSubGroups = filterGroups?.filter(r => subGroup?.includes(r?.finsubgroupid));
    const lsIds = lsRows?.map(r => r?.lsId);
    return filterSubGroups?.filter(r => lsIds?.includes(r?.leadsheetid));
  }

  static transformAmorCalcRows(rows: AmortizationDetailModel[]) {
    if (!rows) {
      return [];
    }
    rows.forEach(r => {
      r.hasHalfYearRule = r?.halfYearRule === 'Yes';
      r?.details?.forEach(d => {
        d.amount = this.formatToNorthAmericanStandard(d?.amount);
        d.amortization = this.formatToNorthAmericanStandard(d?.amortization);
        d.usefulLife = this.formatToNorthAmericanStandard(d?.usefulLife);
        d.residualValue = this.formatToNorthAmericanStandard(d?.residualValue);
        d.rowType = this.getRowType(d?.description);
      });
    });
    return rows;
  }

  static formatToNorthAmericanStandard(value: any): string {
    if (isNaN(value) || !value) {
      return '0.00';
    }
    const roundedValue = Number(value).toFixed(2);
    const isNegative = Number(roundedValue) < 0;
    const formattedValue = Math.abs(Number(roundedValue))
      .toFixed(2)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return isNegative ? `(${formattedValue})` : formattedValue;
  }

  static getRowType(type: string): 'OPENING' | 'TOTAL' | 'ADD' | 'DIS' {
    switch (type) {
      case 'Opening Balance':
        return 'OPENING';
      case 'Additions':
        return 'ADD';
      case 'Dispositions':
        return 'DIS';
      case 'Total Amortization':
        return 'TOTAL';
    }
  }

  static transformScheduleWithDetail(schedule: AmortizationScheduleModel[], details: AmortizationDetailModel[] , generalLedger: CAASGlModel[]) {
    schedule?.forEach(s => {
      if (s?.rowType === 'TB') {
        const detail = details?.find(d => d?.accountName === s?.description);
        const glInfo = generalLedger?.filter(g => g?.AccountName === s?.description);
        s.calculations = JSON.parse(JSON.stringify(detail));
        s.generalLedger = JSON.parse(JSON.stringify(glInfo));
      }
    });
    return JSON.parse(JSON.stringify(schedule));
  }

  static transformDetailsForExport(schedule: AmortizationScheduleModel[]) {
    const tbRows = schedule?.filter(s => s?.rowType === 'TB');
    tbRows?.forEach(t => {
      t?.calculations?.details?.forEach(d => {
        d.accountName = t.calculations.accountName;
        d.halfYearRule = t.calculations.halfYearRule;
        d.method = t.calculations.method;
      });
    });
    const details = tbRows?.map(r => r?.calculations?.details).flat(Infinity);
    return details;
  }

  static showFormattedNumber(data: number) {
    if (data > 0) {
      return data.toLocaleString('en-us');
    } else if (data < 0) {
      const absoluteNumber = data * -1;
      const formatted = absoluteNumber.toLocaleString('en-US');
      return '(' + formatted + ')';
    } else {
      return '-';
    }
  }

  static isFirefox(): boolean {
    const userAgent = navigator?.userAgent?.toLowerCase();
    return userAgent?.includes('firefox');
  }

  static getMethodInfo(method: string = '') {
    if (method === 'Straight line') {
      return 1;
    }
    switch (method) {
      case 'Straight line':
        return 1;
      case 'Decline':
        return 2;
      case 'Double Decline':
        return 3;
      case 'Units of Production':
        return 4;
      case 'Sum Of Years Digit':
        return 5;
    }

  }

  static formatTbRows(rows: TbAccountModel[]): TbAccountModel[] {
    if (!rows) {
      return [];
    }
    rows?.forEach(r => r.finalAmount = this.formatToNorthAmericanStandard(r?.finalAmount));
    return rows;
  }

  static formatBankToTbRows(rows: BankToTbTransactionsInterface[]): BankToTbTransactionsInterface[] {
    if (!rows) {
      return [];
    }
    rows?.forEach(r => {
      r.Debit = this.formatToNorthAmericanStandard(r?.Debit);
      r.Credit = this.formatToNorthAmericanStandard(r?.Credit);
    });
    return rows;
  }

  static formatBankToTbNumbers(rows: BankToTbTransactionsInterface[]): BankToTbTransactionsInterface[] {
    if (!rows) {
      return [];
    }
    rows?.forEach(r => {
      r.Debit = this.formatToNumber(r?.Debit?.toString());
      r.Credit = this.formatToNumber(r?.Credit?.toString());
    });
    return rows;
  }

  static formatTbInformation(rows: TbAccountInterface[]) {
    if (!rows) {
      return [];
    }
    rows?.forEach(r => {
      r.finalamount = this.formatToNorthAmericanStandard(r?.finalamount);
      r.PY1 = this.formatToNorthAmericanStandard(r?.PY1);
      r.PY2 = this.formatToNorthAmericanStandard(r?.PY2);
    });
    return rows;
  }

  static formatRentInputs(rent: RentInputInterface[]) {
    rent?.forEach(r => {
      r.rent_details.monthly_amount = this.formatToNorthAmericanStandard(r?.rent_details?.monthly_amount);
      r.rent_details.lease_inducements = this.formatToNorthAmericanStandard(r?.rent_details?.lease_inducements);
      r.rent_details.security_deposit = this.formatToNorthAmericanStandard(r?.rent_details?.security_deposit);
      r.term.free_rent_periods = this.formatToNorthAmericanStandard(r?.term?.free_rent_periods);
    });
    return [...rent];
  }

  static formatPayrollInputs(payroll: PayrollInfoInterface) {
    payroll?.information?.employees?.forEach(e => {
      e.income_tax = this.formatToNorthAmericanStandard(e?.income_tax);
      e.ei_premiums = this.formatToNorthAmericanStandard(e?.ei_premiums);
      e.cpp_contributions = this.formatToNorthAmericanStandard(e?.cpp_contributions);
      e.employment_income = this.formatToNorthAmericanStandard(e?.employment_income);
    })
    return {...payroll} as PayrollInfoInterface;
  }

  static hasValidKeyValue(value: string | number | undefined | null): boolean  {
    if (value === null || value === undefined) return false;
    if (typeof value === 'string') {
      const trimmed = value.trim();
      return trimmed.length > 0 && !isNaN(Number(trimmed));
    }
    if (typeof value === 'number') {
      return !isNaN(value);
    }
    return false;
  };

  static hasValidRentInputs(entries: RentInputInterface[]) {
    if (!entries.length) return false;
    return entries.every(entry => {
      const rd = entry.rent_details;
      const term = entry.term;
      return (
        this.hasValidKeyValue(rd.frequency) &&
        this.hasValidKeyValue(rd.lease_inducements) &&
        this.hasValidKeyValue(rd.monthly_amount) &&
        this.hasValidKeyValue(rd.payment_terms) &&
        this.hasValidKeyValue(rd.security_deposit) &&
        this.hasValidKeyValue(term.start_date) &&
        this.hasValidKeyValue(term.end_date) &&
        this.hasValidKeyValue(term.free_rent_periods)
      );
    });
  }

  static hasValidPayrollInputs(data: PayrollInfoInterface) {
    if (!data) return false;
    const info = data?.information;
    if (
      !this.hasValidKeyValue(info?.employee_count) ||
      !this.hasValidKeyValue(info?.payroll_period_start) ||
      !this.hasValidKeyValue(info?.payroll_period_end) ||
      !this.hasValidKeyValue(data?.payrollProcessType)
    ) {
      return false;
    }

    if (!info?.employees || info?.employees?.length === 0) return false;

    return info?.employees?.every(emp =>
      this.hasValidKeyValue(emp.employment_income)
    );
  }
}
